import React, {PropTypes} from 'react';
import Helmet from 'react-helmet';
import {Link, Route, Switch} from 'react-router-dom';
import {addLocaleData, FormattedMessage, IntlProvider} from 'react-intl';
import CookieBanner from 'react-cookie-banner';
import ViewCookies from 'universal-cookie';
import {API} from '../../settings.js';
import {ajaxGet} from '../../helpers/apiData.js';
import TopBar from '../nav/TopBar';
import BottomBar from '../nav/BottomBar';
import 'react-select/dist/react-select.css';
import ItemList from "./core/ItemList";
import RestaurantHome from "./RestaurantHome";
import Menus from "./Menus";
import EmptyPage from "./core/EmptyPage";
import EventDetail from "./EventDetail";
import ShortList from "./core/ShortList";
import EventList from "./EventList";
import Feedback from "../Feedback";
import ItemDetail from "./core/ItemDetail";
import About from "./About";
import RestaurantFeedback from "./RestaurantFeedback";
import Terms from "../Terms";
import AboutPickly from "../AboutPickly";
import Cookies from "../Cookies";
import RestaurantError from "../RestaurantError";
import Error from "../Error";
import PreLoader from "../PreLoader";
import de from "react-intl/locale-data/de";
import pt from "react-intl/locale-data/pt";
import es from "react-intl/locale-data/es";
import nl from "react-intl/locale-data/nl";
import fr from "react-intl/locale-data/fr";
import it from "react-intl/locale-data/it";
import enMessages from '../../../locales/en-us.json';
import ptMessages from '../../../locales/pt-pt.json';
import esMessages from '../../../locales/es-es.json';
import frMessages from '../../../locales/fr-fr.json';
import deMessages from '../../../locales/de-de.json';
import nlMessages from '../../../locales/nl-nl.json';
import itMessages from '../../../locales/it-it.json';
import WineFilterList from "./core/WineFilterList";

addLocaleData([...pt, ...es, ...fr, ...de, ...nl, ...it]);

const view_cookies = new ViewCookies();


class Restaurant extends React.Component {
  static propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.redirect = true;
    this.lang = "";

    this.state = {
      data: {
        introOptions: [], 
        status: '', 
        default_list_view: '', 
        simple_theme: false, 
        background: '',
        button1_title:'',
        button1_link: '',
        button2_title: '',
        button2_link:'',
        button3_title:'',
        button3_link:''
      },
      social: {},
      languages: [],
      mode: '',
      view: 'home',
      title: '',
      back_btn: false,
      view_toggle: '',
      favsTotal: null
    };

    this.handleViewSort = this.handleViewSort.bind(this);
    this.refreshFav = this.refreshFav.bind(this);
  }

  componentDidMount() {
    this.rest_slug = this.props.match.params.restaurant;

    // check if url have language parameter if not redirect to default language url
    if (this.rest_slug && this.props.match.params.lang.length === 2) {
      // pathname without language
      this.pathname = this.props.location.pathname.substring(4);
      this.lang = this.props.match.params.lang;

      // get languages available for this restaurant
      ajaxGet(API + 'api/restaurant/' + this.rest_slug + '/languages/', this);
    }
    else {
      this.pathname = this.props.location.pathname;
      this.rest_slug = this.props.match.params.lang;
      this.lang = navigator.languages.length > 0 ? navigator.languages[0] : (navigator.language || navigator.userLanguage);
      this.lang = this.lang.substring(0, 2);
      this.props.history.push('/' + this.lang + this.pathname);

      // get languages available for this restaurant
      ajaxGet(API + 'api/restaurant/' + this.rest_slug + '/languages/', this);

      //view_cookies.set('list_view', this.state.data.default_list_view, {path: '/', maxAge: 1300});
    }
  }

  componentDidUpdate() {
    // run after receive the language api call on component didMount
    if (this.redirect) {
      this.checkRestaurantLanguage();
    }
    if (this.lang !== this.props.match.params.lang) {
      this.lang = this.props.match.params.lang;
      this.getData(this.lang);
    }
/*
    if (cookies.get('list_view') !== undefined) {

    }*/
  }

  setInfo = (title, view, back, view_toggle) => {
    if (this.state.title !== title || this.state.view !== view || this.state.back !== back) {
      if (view_toggle === 'default') {
        if (view_cookies.get('list_view') === undefined) {
          this.setState({title: title, view: view, back_btn: back, view_toggle: this.state.data.default_list_view});
        }
        else {
          this.setState({title: title, view: view, back_btn: back, view_toggle: view_cookies.get('list_view')});
        }
      }
      else {
        this.setState({title: title, view: view, back_btn: back, view_toggle: view_toggle});
      }
    }
  };

  cookieMessageTrans() {
    return (
      <p className="terms-notice">
        <FormattedMessage id="cookie-notice">
          {(message) => <span>{message}</span>}
        </FormattedMessage>
        <FormattedMessage id="cookie-link">
          {(message) => <Link to={'/' + this.lang + '/' + this.rest_slug + '/cookies-usage'}>{message}</Link>}
        </FormattedMessage>
      </p>
    );
  }

  handleViewSort(list_view) {
    this.setState({view_toggle: list_view});
    view_cookies.set('list_view', list_view, {path: this.rest_slug + '/', maxAge: 1300});
  }

  // check language for ReactINTL double check the default language
  checkLanguage() {
    const languages = ['en', 'pt', 'es', 'fr', 'de', 'nl', 'it'];
    const currentLangIndex = languages.indexOf(this.props.match.params.lang);
    const locales = [['en', enMessages], ['pt', ptMessages], ['es', esMessages], ['fr', frMessages],
      ['de', deMessages], ['nl', nlMessages], ['it', itMessages]];

    // check if language in url is available for the app, if not render default language present in index 0 of array
    if (currentLangIndex !== -1) {
      return ({locale: locales[currentLangIndex][0], messages: locales[currentLangIndex][1]});
    }
    return ({locale: locales[0][0].toUpperCase(), messages: locales[0][1]});
  }

  // Check if the language in url are available for Restaurant
  checkRestaurantLanguage() {
    let lang = "";

    // check if already received the api data
    if(this.state.data.languages){
      // check if the language selected is in the available languages of restaurant
      for (let i = 0, l = this.state.data.languages.length; i < l; i++) {
      if (this.lang === this.state.data.languages[i].code) {
        lang = this.lang;
        break;
      }
    }
    //re render new data based on language
    this.getData(lang);
    }

  }

  // Get Restaurant data From API
  getData(language) {
    // turn off pre loader
    this.redirect = false;

    // re render info about restaurant based on language, if there' no language, than render with default language
    if (language) {
      ajaxGet(API + language + '/api/restaurant/' + this.rest_slug + '/', this);
    }
    else {
      this.props.history.push('/' + this.state.data.default_language.code + this.pathname);
      ajaxGet(API + this.state.data.default_language.code + '/api/restaurant/' + this.rest_slug + '/', this);
    }
  }

  refreshFav(total) {
    this.setState({favsTotal: total});
  }

  render() {
    // CHECKING FOR ERRORS FROM THE API
    let wine_url = '/empty';

    if (this.state.data.wine_slug !== null) {
      wine_url = '/wine/' + this.state.data.wine_slug;
    }

    if (this.redirect) {
      return (<div><PreLoader loading="loading"/></div>);
    }

    if (this.state.data.status !== "error") {
      return (
        <IntlProvider locale={this.checkLanguage().locale} messages={this.checkLanguage().messages}>
          <div>
            <Helmet title={this.state.data.name + ' @ Pickly'} meta={[
              {name: "description", content: ""}
            ]}/>
            <div>
              <TopBar restaurant={this.state.data.slug} name={this.state.data.name}
                      city={this.state.data.city} country={this.state.data.country} lang={this.props.match.params.lang}
                      social={this.state.data.social} view={this.state.view} languages={this.state.data.languages}
                      title={this.state.title} wine_slug={wine_url} package={this.state.data.package}
                      back_btn={this.state.back_btn} viewToggle={this.state.view_toggle} viewSort={this.handleViewSort}
                      history={this.props.history} {...this.props.location}
                      match={this.props.match}/>

              <CookieBanner disableStyle={true}
                            message={this.cookieMessageTrans()}
                            onAccept={() => {
                            }}
                            cookie="user-has-accepted-cookies"
                            buttonMessage="Ok"
              />

              <Switch>
                <Route exact path="/:lang/:restaurant"
                       render={() => <RestaurantHome
                         categories={this.state.data.categories}
                         city={this.state.data.city}
                         country={this.state.data.country}
                         history={this.props.history}
                         intro_options={this.state.data.intro_options}
                         match={this.props.match}
                         name={this.state.data.name}
                         package={this.state.data.package}
                         slug={this.state.data.slug}
                         view_info={this.setInfo}
                         logo={this.state.data.logo}
                         simpleTheme={this.state.data.simple_theme}
                         wineSlug={wine_url}
                         backgroundImage={this.state.data.background}
                         button1Title={this.state.data.button1_title}
                         button1Link={this.state.data.button1_link}
                         button2Title={this.state.data.button2_title}
                         button2Link={this.state.data.button2_link}
                         button3Title={this.state.data.button3_title}
                         button3Link={this.state.data.button3_link}
                         
                         />}
                />

                <Route exact path="/:lang/:restaurant/empty"
                       render={() => <EmptyPage view_info={this.setInfo}/>}
                />

                <Route exact path="/:lang/:restaurant/terms"
                       render={() => <Terms view_info={this.setInfo} match={this.props.match}/>}
                />

                <Route exact path="/:lang/:restaurant/pickly"
                       render={() => <AboutPickly view_info={this.setInfo} match={this.props.match}
                                                  slug={this.state.data.slug}/>}
                />

                <Route exact path="/:lang/:restaurant/cookies-usage"
                       render={() => <Cookies view_info={this.setInfo} match={this.props.match}/>}
                />

                <Route exact path="/:lang/:restaurant/menu"
                       render={() => <Menus view_info={this.setInfo} match={this.props.match}/>}
                />

                <Route exact path="/:lang/:restaurant/about"
                       render={() => <About view_info={this.setInfo} match={this.props.match}/>}
                />

                <Route exact path="/:lang/:restaurant/events"
                       render={() => <EventList view_info={this.setInfo} history={this.props.history}
                                                match={this.props.match}/>}
                />

                <Route exact path="/:lang/:restaurant/events/:event"
                       render={(props) => <EventDetail view_info={this.setInfo}
                                                       history={this.props.history}
                                                       match={this.props.match}
                                                       slug={props.match.params.event}/>}
                />

                <Route exact path="/:lang/:restaurant/feedback" component={Feedback}/>

                <Route exact path="/:lang/:restaurant/restaurant-feedback"
                       render={() => <RestaurantFeedback view_info={this.setInfo} match={this.props.match}/>}
                />

                <Route exact path="/:lang/:restaurant/items/featured"
                       render={() => <ItemList view_info={this.setInfo}
                                               viewToggle={this.state.view_toggle}
                                               category={this.state.data.category}
                                               history={this.props.history}
                                               location={this.props.location}
                                               match={this.props.match}
                                               wine_slug={this.state.data.wine_slug}
                                               favsTotal={this.refreshFav}/>}
                />


                <Route exact path="/:lang/:restaurant/items/shortlist"
                       render={() => <ShortList view_info={this.setInfo}
                                                viewToggle={this.state.view_toggle}
                                                match={this.props.match}
                                                wine_slug={this.state.data.wine_slug}
                                                history={this.props.history}
                                                favsTotal={this.refreshFav}/>}
                />

                <Route exact path="/:lang/:restaurant/items/:category"
                       render={(props) => <ItemList view_info={this.setInfo}
                                                    category={props.match.params.category}
                                                    viewToggle={this.state.view_toggle}
                                                    history={this.props.history}
                                                    location={this.props.location}
                                                    match={this.props.match}
                                                    wine_slug={this.state.data.wine_slug}
                                                    favsTotal={this.refreshFav}/>}
                />

                <Route exact path="/:lang/:restaurant/items/filter/:filter"
                       render={(props) => <ItemList view_info={this.setInfo}
                                                    filter={props.match.params.filter}
                                                    viewToggle={this.state.view_toggle}
                                                    history={this.props.history}
                                                    location={this.props.location}
                                                    match={this.props.match}
                                                    wine_slug={this.state.data.wine_slug}
                                                    favsTotal={this.refreshFav}/>}
                />
                <Route exact path="/:lang/:restaurant/items/:category/:item"
                       render={(props) => <ItemDetail view_info={this.setInfo}
                                                      item={props.match.params.item}
                                                      category={props.match.params.category}
                                                      history={this.props.history}
                                                      match={this.props.match}
                                                      package={this.state.data.package}
                                                      wine_slug={this.state.data.wine_slug}
                                                      favsTotal={this.refreshFav}/>}
                />

                <Route exact path="/:lang/:restaurant/wine/:category/"
                       render={(props) => <WineFilterList {...props} view_info={this.setInfo}/>}
                />
                <Route exact path="/:lang/:restaurant/wine/:category/:winetype"
                       render={(props) => <WineFilterList {...props} view_info={this.setInfo}/>}
                />

                <Route render={() => <RestaurantError lang={this.props.match.lang}
                                                      next={this.props.next}
                                                      restaurant={this.state.data.name}
                                                      view=""
                                                      view_info={this.setInfo}/>} status={404}/>

              </Switch>

              <BottomBar restaurant={this.state.data.slug}
                         lang={this.props.match.params.lang}
                         view={this.state.view}
                         wine_slug={wine_url}
                         package={this.state.data.package}
                         favsTotal={this.state.favsTotal}/>
            </div>
          </div>
        </IntlProvider>
      );
    }
    //API GAVE ME AN ERROR :(
    else {
      return (
        <Error restaurant="" lang={this.lang}/>
      );
    }
  }
}

export default Restaurant;
/*

if (process.env.NODE_ENV !== 'production') {
  const {whyDidYouUpdate} = require('why-did-you-update');
  whyDidYouUpdate(React, {exclude: /^FormattedMessage|Link|Route|Router|IntlProvider|FormattedDate/});
}

*/




/** WEBPACK FOOTER **
 ** ./src/components/restaurant/Restaurant.js
 **/